import { Action } from 'redux';
import { CitaDto } from '../../types/citas/Citas';

export const FETCH_CITAS_REQUEST = 'FETCH_CITAS_REQUEST';
export const FETCH_CITAS_SUCCESS = 'FETCH_CITAS_SUCCESS';
export const FETCH_CITAS_FAILURE = 'FETCH_CITAS_FAILURE';

export const CREATE_CITA_REQUEST = 'CREATE_CITA_REQUEST';
export const CREATE_CITA_SUCCESS = 'CREATE_CITA_SUCCESS';
export const CREATE_CITA_FAILURE = 'CREATE_CITA_FAILURE';

export const UPDATE_CITA_REQUEST = 'UPDATE_CITA_REQUEST';
export const UPDATE_CITA_SUCCESS = 'UPDATE_CITA_SUCCESS';
export const UPDATE_CITA_FAILURE = 'UPDATE_CITA_FAILURE';

export const DELETE_CITA_REQUEST = 'DELETE_CITA_REQUEST';
export const DELETE_CITA_SUCCESS = 'DELETE_CITA_SUCCESS';
export const DELETE_CITA_FAILURE = 'DELETE_CITA_FAILURE';

export const CREATE_CITA_WARNING = 'CREATE_CITA_WARNING';

export interface FetchCitasRequestAction extends Action<typeof FETCH_CITAS_REQUEST> {
  type: typeof FETCH_CITAS_REQUEST;
}

export interface FetchCitasSuccessAction extends Action<typeof FETCH_CITAS_SUCCESS> {
  type: typeof FETCH_CITAS_SUCCESS;
  payload: {
    data: CitaDto[];
  };
}

export interface FetchCitasFailureAction extends Action<typeof FETCH_CITAS_FAILURE> {
  type: typeof FETCH_CITAS_FAILURE;
  payload: string;
}

export interface CreateCitaRequestAction extends Action<typeof CREATE_CITA_REQUEST> {
  type: typeof CREATE_CITA_REQUEST;
}

export interface CreateCitaSuccessAction extends Action<typeof CREATE_CITA_SUCCESS> {
  type: typeof CREATE_CITA_SUCCESS;
  payload: CitaDto;
}

export interface CreateCitaFailureAction extends Action<typeof CREATE_CITA_FAILURE> {
  type: typeof CREATE_CITA_FAILURE;
  payload: string;
}

export interface UpdateCitaRequestAction extends Action<typeof UPDATE_CITA_REQUEST> {
  type: typeof UPDATE_CITA_REQUEST;
}

export interface UpdateCitaSuccessAction extends Action<typeof UPDATE_CITA_SUCCESS> {
  type: typeof UPDATE_CITA_SUCCESS;
  payload: CitaDto;
}

export interface UpdateCitaFailureAction extends Action<typeof UPDATE_CITA_FAILURE> {
  type: typeof UPDATE_CITA_FAILURE;
  payload: string;
}

export interface DeleteCitaRequestAction extends Action<typeof DELETE_CITA_REQUEST> {
  type: typeof DELETE_CITA_REQUEST;
}

export interface DeleteCitaSuccessAction extends Action<typeof DELETE_CITA_SUCCESS> {
  type: typeof DELETE_CITA_SUCCESS;
  payload: string;
}

export interface DeleteCitaFailureAction extends Action<typeof DELETE_CITA_FAILURE> {
  type: typeof DELETE_CITA_FAILURE;
  payload: string;
}

export interface CreateCitasWarningAction extends Action<typeof CREATE_CITA_WARNING> {
  type: typeof CREATE_CITA_WARNING;
  payload: {
    data: CitaDto[];
  };
}


export type CitasActionTypes =
  | FetchCitasRequestAction
  | FetchCitasSuccessAction
  | FetchCitasFailureAction
  | CreateCitaRequestAction
  | CreateCitaSuccessAction
  | CreateCitaFailureAction
  | UpdateCitaRequestAction
  | UpdateCitaSuccessAction
  | UpdateCitaFailureAction
  | DeleteCitaRequestAction
  | DeleteCitaSuccessAction
  | DeleteCitaFailureAction
  |CreateCitasWarningAction;